import { call, takeLatest, put, select } from "redux-saga/effects";
import {
  addVehicleAction,
  addVehicleCategoryAction,
  getAllVehiclesFetchAction,
  showVehicleCategoryAction,
  updateVehicleAction,
} from "../api/vehicle-action";
import {
  getAllVehicles,
  getCategories,
  setUpdate,
  setVehicleIsLoading,
  vehicleCreating,
} from "../redux/app/vehicle/vehicle-slice";
import { toast } from "react-toastify";

const getAuthState = (state) => state.auth;

export function* addVehicleSaga(action) {
  let authState = yield select(getAuthState);
  try {
    yield put(vehicleCreating({ creating: true }));
    const response = yield call(addVehicleAction, action.payload);
    if (response) {
      toast.success("Vehicle Added Successfully");
      yield put(vehicleCreating({ creating: false }));
      yield put({
        type: "SHOW_VEHICLE_CATEGORY",
        payload: {
          token: authState.token,
        },
      });
    }
  } catch (error) {}
}

export function* getAllVehiclesSaga() {
  try {
    yield put(
      setVehicleIsLoading({
        vehicelsLoading: true,
      })
    );
    const response = yield call(getAllVehiclesFetchAction);

    yield put(
      getAllVehicles({
        allVehicles: response.data,
      })
    );
  } catch (error) {}
}

export function* vehicleSaga(action) {
  try {
    yield put(setUpdate({ updating: true }));
    const response = yield call(updateVehicleAction, action.payload);

    if (response.status === 200) {
      yield put({
        type: "GET_ALL_VEHICLES",
      });
    }
  } catch (error) {
  } finally {
    yield put(setUpdate({ updating: false }));
  }
}

export function* addVehicleCategorySaga(actions) {
  const response = yield call(addVehicleCategoryAction, actions.payload);

  if (response.status === 200) {
    yield put({
      type: "SHOW_VEHICLE_CATEGORY",
      payload: {
        token: actions.payload.token,
      },
    });
  }
}

export function* showVehicleCategorySaga(actions) {
  yield put(
    setVehicleIsLoading({
      vehicelsLoading: true,
    })
  );
  const response = yield call(showVehicleCategoryAction, actions.payload);

  if (response.status === 200) {
    yield put(
      setVehicleIsLoading({
        vehicelsLoading: false,
      })
    );
    yield put(
      getCategories({
        categories: response.data,
      })
    );
  }
}

export function* watchVehicleAsync() {
  yield takeLatest("GET_ALL_VEHICLES", getAllVehiclesSaga);
  yield takeLatest("UPDATE_VEHICLE", vehicleSaga);
  yield takeLatest("ADD_VEHICLE", addVehicleSaga);
  yield takeLatest("ADD_VEHICLE_CATEGORY", addVehicleCategorySaga);
  yield takeLatest("SHOW_VEHICLE_CATEGORY", showVehicleCategorySaga);
}
